import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import { List } from "immutable";
import { FormattedMessage } from "react-intl";

import { getCampaignCategories, getEntityId, getSelectCategoryCopy } from "data/entity";

import { getCampaign } from "data/parent-campaign";

import {
  getAllocationType,
  getSearchQuery,
  selectCategory,
  getFilteredAllocations,
  getHasFetched,
  getSelectedAllocations,
  getSelectedCategory,
  getHasMounted,
  selectAllocation,
  receivedAllocations,
  triggerIsMounted,
  fetchAllocations,
} from "data/giving-form/allocation-selection";

import { GIVING_FORM_PAGINATION_SCOPE } from "data/giving-form";

import { setInitialPagination } from "data/pagination";

import SearchAllocations from "./SearchAllocations";
import SelectedAllocations from "./SelectedAllocations";
import SelectOptions from "lib/components/SelectOptions";

class SearchContainer extends React.PureComponent {
  static propTypes = {
    fetchedAllocations: PropTypes.bool,
    searchQuery: PropTypes.string,
    selectedCategory: PropTypes.string,
    allocations: PropTypes.instanceOf(List),
  };

  componentDidMount() {
    const {
      allocationType,
      selectAllocation,
      receivedAllocations,
      parentCampaign,
      totalAmount,
      hasMounted,
      triggerIsMounted,
      dontPreselectCampaign,
      shellCampaign,
    } = this.props;

    if (allocationType === "campaign" && parentCampaign && !hasMounted) {
      if (!shellCampaign) {
        receivedAllocations([parentCampaign]);
      }
      triggerIsMounted();

      if (!dontPreselectCampaign) {
        selectAllocation(parentCampaign, true, totalAmount);
      }
    }
  }

  handleSelectCategory = (category) => {
    const { campaignId, allocationType, entityId } = this.props;
    const { selectCategory, fetchAllocations, setInitialPagination } = this.props;

    selectCategory(category);
    fetchAllocations(campaignId, allocationType, {
      entityId,
      resetPage: true,
      category,
      fundsPage: -1,
      page: 1,
    }).then(({ total }) => setInitialPagination({ total }));
  };

  renderCategories() {
    const { categories, selectCategoryCopy, selectedCategory, allocationType } =
      this.props;

    if (allocationType === "campaign") {
      return (
        <div className="m-sm-b">
          <SelectOptions
            displayText={selectCategoryCopy}
            items={categories}
            selected={selectedCategory}
            selectItemAction={this.handleSelectCategory}
          />
        </div>
      );
    }
  }

  render() {
    const { allocations, searchQuery, selectedCategory, fetchedAllocations } = this.props;

    if (
      fetchedAllocations &&
      allocations.count() <= 0 &&
      !searchQuery &&
      !selectedCategory
    ) {
      return null;
    }

    return (
      <div className="voting-modal-body-inside">
        <div className="givingform-flexbox">
          <div className="accessibility-paragraph">
            <FormattedMessage id="giveSelectFund" />
          </div>
          <div className="category-select-container">{this.renderCategories()}</div>
        </div>
        <div className="giving-form-search">
          <div className="giving-form-search-container">
            <SearchAllocations />
          </div>
          <div className="giving-form-search-container search-right">
            <SelectedAllocations />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    fetchedAllocations: getHasFetched(state),
    searchQuery: getSearchQuery(state),
    allocations: getFilteredAllocations(state),
    categories: getCampaignCategories(state),
    selectedAllocations: getSelectedAllocations(state),
    selectedCategory: getSelectedCategory(state),
    selectCategoryCopy: getSelectCategoryCopy(state),
    allocationType: getAllocationType(state),
    parentCampaign: getCampaign(state)("giving_form"),
    campaignId: getCampaign(state)("giving_form").get("id"),
    totalAmount: formValueSelector("donation")(state, "amount"),
    hasMounted: getHasMounted(state),
    entityId: getEntityId(state),
  };
};

const mapActionCreators = {
  receivedAllocations,
  selectAllocation,
  triggerIsMounted,
  selectCategory,
  fetchAllocations,
  setInitialPagination({ total }) {
    return setInitialPagination({ scope: GIVING_FORM_PAGINATION_SCOPE, total });
  },
};

export default connect(mapStateToProps, mapActionCreators)(SearchContainer);
